import {Box} from '@viptech/react-components'

import {useSnackbar} from 'notistack'
import LoadMoreButton from 'src/components/Button/LoadMoreButton'
import Table from 'src/components/table/Table'
import TableData from 'src/components/table/components/tableData/TableData'
import RowHover from '../../../../components/RowHover/RowHover'

import {useNavigate} from 'react-router-dom'
import LinkWithAction from 'src/components/LinkWithAction'
import MenuOptions from 'src/pages/edge-servers/components/table/OptionsMenuComponent'
import StatusIcon from 'src/pages/edge-servers/components/table/StatusIcon'
import {EdgeServersDTO} from 'src/services/api'
import {ContainerTable, NoDataBox} from './styles'

const columnsOnTable = [
  {
    id: 'status',
    name: 'Status',
  },
  {
    id: 'name',
    name: 'Nome do Local',
  },

  {
    id: 'id',
    name: 'ID Dispositivo',
  },
  {
    id: 'mac',
    name: 'MAC Address',
  },
  {
    id: 'lastConnection',
    name: 'Última Conexão',
  },
  {
    id: 'cameras',
    name: 'Quantidade de Câmeras',
  },
  {
    id: 'options',
    name: '',
  },
]

type Props = {
  isLoadingAlarms: boolean
  fetchNextPage: () => void
  isFetchingNextPage: boolean
  hasNextPage: boolean
  servers: EdgeServersDTO[]
}

function EdgeServersTable(props: Props) {
  const {isLoadingAlarms, fetchNextPage, isFetchingNextPage, hasNextPage, servers} = props
  const {enqueueSnackbar} = useSnackbar()
  const navigate = useNavigate()

  function handleLoadMore() {
    if (!hasNextPage) return enqueueSnackbar('Todos os servidores de borda já foram carregados', {variant: 'info'})
    fetchNextPage()
  }

  return (
    <Box height='100%' padding='0 20px'>
      <ContainerTable>
        <Table isLoading={isLoadingAlarms} skeletonRowsAmount={20} isOpenAdvancedSearch={false} columns={columnsOnTable}>
          {servers
            .sort((a, b) => a.id - b.id)
            .map((row) => {
              return (
                <RowHover id={`row-${row.id}`} cursorType='auto'>
                  <TableData padding='0 0 0 15px'>
                    <StatusIcon server={row} />
                  </TableData>
                  <TableData>
                    <LinkWithAction
                      onAuxClick={() => window.open(`/registers/edge-servers?id=${row.id}`, 'blank')}
                      onClick={() => navigate(`/registers/edge-servers?id=${row.id}`)}>
                      {row.clientName ?? '-'}
                    </LinkWithAction>
                  </TableData>
                  <TableData>{row.id}</TableData>
                  <TableData>{row.macAddress}</TableData>
                  <TableData>{row.lastConnectedAt ? new Date(row.lastConnectedAt).toLocaleString('pt-br') : '-'}</TableData>
                  <TableData>{row.cameras}</TableData>
                  <TableData>
                    <MenuOptions server={row} />
                  </TableData>
                </RowHover>
              )
            })}
        </Table>
        {!isLoadingAlarms && servers.length === 0 && <NoDataBox>Nenhum registro encontrado</NoDataBox>}
      </ContainerTable>

      {!isLoadingAlarms && servers.length > 0 && (
        <Box style={{display: 'flex', justifyContent: 'center', alignItems: 'center', paddingTop: '6px'}}>
          <LoadMoreButton onClick={() => handleLoadMore()} isLoading={isFetchingNextPage} />
        </Box>
      )}
    </Box>
  )
}

export default EdgeServersTable
